export const SCHEDULER_URL = "/book";

// Sends visitors to the internal booking calendar (replaces the old Zoom popup).
export const openCalendly = (e) => {
  if (e && typeof e.preventDefault === "function") e.preventDefault();
  if (typeof window !== "undefined") window.location.href = "/book";
};

export const NAV_LINKS = [
  { label: "Services", id: "services" },
  { label: "Method", id: "method" },
  { label: "Pricing", id: "pricing" },
  { label: "Work", id: "work" },
  { label: "Contact", id: "contact" },
];

// ─────────────────────────────────────────────────────────────────────────
// SHOWCASE CAROUSEL SLIDES  (homepage cinematic zoom carousel)
// 👉 Replace `image` with your own photo URLs later. You can add/remove slides
//    freely — just keep the { image, title, subtitle } shape. Captions are
//    optional; set title/subtitle to "" to hide them.
//    `link` = where the slide clicks through to: a plan page ("/pricing/<slug>")
//    or an on-page section ("#work", "#pricing", "#about"). `cta` = button label.
// ─────────────────────────────────────────────────────────────────────────
export const SHOWCASE_SLIDES = [
  { image: "https://images.unsplash.com/photo-1780943004155-1b2c5424fb2e?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000", title: "Brand-first design", subtitle: "Identity systems that command attention", link: "/pricing/hd-brand-authority", cta: "Explore plan" },
  { image: "https://images.unsplash.com/photo-1670177257750-9b47927f68eb?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000", title: "Cinematic product stories", subtitle: "Visuals that make people stop scrolling", link: "#work", cta: "See results" },
  { image: "https://images.pexels.com/photos/13186049/pexels-photo-13186049.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=2000", title: "Premium packaging & assets", subtitle: "Every touchpoint, on brand", link: "/pricing/hd-signature-presence", cta: "Explore plan" },
  { image: "https://images.unsplash.com/photo-1780943004195-3bd30f748872?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000", title: "Launches that convert", subtitle: "From concept to booked clients", link: "/pricing/hd-cinematic-website", cta: "Explore plan" },
  { image: "https://static.prod-images.emergentagent.com/jobs/b7321a98-e256-4cb1-ae2f-2d5f3d3ad9af/images/d0c9a1c277d8319e0330da84328c24c56284f560c41cb09ca2de0b403c06f432.jpeg", title: "Founder-led strategy", subtitle: "Direct access to the person building your growth — no layers, no runaround", link: "#about", cta: "Meet the Founder" },
];

export const PRICING_PLANS = [
  {
    name: "HughLaunch Starter",
    slug: "basic-build",
    purchaseUrl: "https://buy.stripe.com/4gM14n1Jhd2HgO77wKbQY0a",
    price: "$500",
    period: "one-time",
    badge: "The Foundation",
    tagline: "A professional foundation for businesses that just need to get online — not the full growth system.",
    image: "https://static.prod-images.emergentagent.com/jobs/b7321a98-e256-4cb1-ae2f-2d5f3d3ad9af/images/769bbf033f42dd9fd3bee9389e2e59db15caa2f585b0702bb1679d620b998d61.jpeg",
    overview: "The HughLaunch Starter is our entry point — a clean, professional foundation for businesses that simply need to look credible online, fast. To be clear: this is not the full HughLaunch growth system. There's no acquisition engine or automation here — just a sharp, mobile-first presence with a clear path for visitors to contact or book you, live within 48 hours. It's the perfect first step, built so you can upgrade into a full Growth System the moment you're ready.",
    features: [
      "Basic Website Layout",
      "Seamless Landing Page",
      "Mobile Friendly Design",
      "Contact Form / Booking Link",
      "Social Media Links",
      "Copy Cleanup",
      "Brand Colors + Fonts",
      "Client Portal Built for Your Brand — Connected to Stripe",
    ],
    delivery: "Delivered in 24–48 hours",
    whoFor: [
      "New businesses that need a credible online presence this week, not next quarter",
      "Solo operators and tradespeople whose customers Google them before calling",
      "Anyone burned by DIY builders who wants a professional result without a big investment",
      "Businesses planning to grow into a full acquisition system later — this foundation upgrades cleanly",
    ],
    process: [
      { h: "Share your details", d: "Send your logo, brand colors and service info through a short intake — fifteen minutes of your time is all we need to get started." },
      { h: "We design and build", d: "A clean, mobile-first landing page with your booking link or contact form, copy cleanup included, structured so search engines can actually read it." },
      { h: "Review and launch", d: "You review the live preview, we make final tweaks, and your site goes live on your domain within 24–48 hours of kickoff." },
      { h: "Your portal opens", d: "You get a HughLaunch client portal connected to Stripe — invoices, files and support requests live in one place from day one." },
    ],
    faqs: [
      { q: "Who is the HughLaunch Starter for?", a: "New businesses, solo operators, and anyone who needs a clean, credible web presence live quickly without a big investment." },
      { q: "Can I upgrade later?", a: "Absolutely. Everything is built so you can move up to a Cinematic Website or Signature Presence whenever you're ready to grow." },
      { q: "What do you need from me?", a: "Your logo (if you have one), brand colors, and the key info about your services. We handle the rest." },
    ],
  },
  {
    name: "HD Cinematic Website",
    slug: "hd-cinematic-website",
    purchaseUrl: "https://buy.stripe.com/eVq4gz2Nl0fV55pcR4bQY09",
    price: "$1,500",
    period: "one-time",
    badge: "The Bridge",
    tagline: "For businesses that have outgrown the DIY look and need a digital presence that finally matches the quality of their work.",
    image: "https://static.prod-images.emergentagent.com/jobs/b7321a98-e256-4cb1-ae2f-2d5f3d3ad9af/images/fa3598a1ffad8360202f616b1b0b0e361902f88026fac05d3a6ef7eab97a3d7e.jpeg",
    overview: "You've outgrown the DIY look — the HD Cinematic Website gives you a digital presence that finally matches the quality of your work. We craft a custom, animated multi-page experience with imagery, video and smooth motion that positions your brand as the premium choice in your market. Every section is engineered to hold attention and guide visitors toward action, while a basic SEO setup gives you a head start in search. This is the site that makes prospects feel your brand before they ever speak to you.",
    features: [
      "Custom Cinematic Design",
      "HughLaunch Starter Features",
      "3–5 Pages Included",
      "Image + Video",
      "Visual Direction",
      "Smooth Animations",
      "Brand Story Section",
      "Basic SEO Setup",
      "Your Own Built-In Content Operating System — AI Posts, Visuals, Calendar & Auto-Publishing",
      "Client Portal Built for Your Brand — Connected to Stripe",
    ],
    delivery: "Delivered in 3 days",
    whoFor: [
      "Established businesses whose website undersells the quality of their actual work",
      "Premium service providers who compete on craft, not price — and need a site that shows it",
      "Brands ready to stop looking like a template and start looking like the obvious choice",
    ],
    process: [
      { h: "Visual direction session", d: "We define the look, motion and story of your brand — imagery, typography and the feeling a visitor should have in the first five seconds." },
      { h: "Design and animation", d: "Three to five custom pages with smooth animations, video and a brand story section engineered to hold attention and guide visitors toward action." },
      { h: "Build, SEO and launch", d: "We build the site, wire up a basic SEO setup — titles, descriptions, structure and page speed — and launch in about three days." },
      { h: "Portal handoff", d: "Your client portal opens with your files, invoices and a direct line to us for anything you need after launch." },
    ],
    faqs: [
      { q: "What makes it 'cinematic'?", a: "Custom motion design, video, and a considered visual direction — the kind of polish usually reserved for big brands, delivered for your business." },
      { q: "How many pages are included?", a: "Three to five pages, typically Home, About, Services, Work and Contact — tailored to how your customers make decisions." },
      { q: "Is SEO included?", a: "Yes — a basic SEO setup so your pages are structured, fast and discoverable from day one." },
    ],
  },
  {
    name: "HD Signature Presence",
    slug: "hd-signature-presence",
    purchaseUrl: "https://buy.stripe.com/7sY8wP1Jh0fV69tbN0bQY0b",
    price: "$2,500",
    period: "1st month management included",
    featured: true,
    badge: "Most Popular",
    tagline: "A complete presence with lead capture, hosting and analytics — managed.",
    image: "https://static.prod-images.emergentagent.com/jobs/b7321a98-e256-4cb1-ae2f-2d5f3d3ad9af/images/e641ecc55298082ba028c88d500b9185a170a7951fc6511086ab65e36c241bce.jpeg",
    overview: "HD Signature Presence is a done-for-you growth foundation — and the package that best represents what HughLaunch is about. On top of a cinematic website with a defined scope of up to 10 pages, we wire up lead capture, custom domain hosting, and the analytics stack — Google Search Console and Google Analytics — so you can see exactly where customers come from. Your first month of management is included, meaning we monitor, tune and support your site while you focus on running the business.",
    features: [
      "HD Cinematic Website",
      "Up to 10 Pages, Scoped to Your Goals",
      "Lead Capture Setup",
      "Custom Domain Hosting",
      "Google Search Console Setup",
      "Google Analytics Setup",
      "Advanced SEO Features Powered by AI",
      "Your Own Built-In Content Operating System — AI Posts, Visuals, Calendar & Auto-Publishing",
      "Client Portal Built for Your Brand — Connected to Stripe",
    ],
    delivery: "Delivered in 4 days",
    whoFor: [
      "Businesses that want leads, not just a pretty website — capture, tracking and follow-through included",
      "Owners who don't want to manage hosting, analytics or website updates themselves",
      "Local businesses and service providers ready to know exactly where their customers come from",
    ],
    process: [
      { h: "Strategy and scoping", d: "We map up to ten pages around how your customers actually make decisions — services, locations, proof and clear conversion paths." },
      { h: "Cinematic build with lead capture", d: "The full cinematic website plus forms, booking and lead-capture wiring, so every enquiry lands somewhere and gets followed up." },
      { h: "Analytics stack setup", d: "Custom domain hosting, Google Analytics and Google Search Console configured — you can see traffic, rankings and lead sources from day one." },
      { h: "Your first month, managed", d: "For thirty days we monitor, tune and update the site while you run the business. Continues at $250/month after — cancel anytime." },
    ],
    note: "Important: After your first month of included management, HD Signature Presence continues at $250/month. You can cancel anytime — by either party, for any reason.",
    faqs: [
      { q: "What does 'management included' mean?", a: "For the first month we host, monitor and fine-tune your site, and make small updates so it stays fast and effective." },
      { q: "Will I be able to track results?", a: "Yes — Google Analytics and Search Console are configured so you can see traffic, rankings and where your leads come from." },
      { q: "How many pages are included?", a: "Up to 10 pages, scoped together during strategy — enough for services, locations and proof. Need more later? We add them as part of ongoing management." },
    ],
  },
  {
    name: "HD Brand Authority",
    slug: "hd-brand-authority",
    purchaseUrl: "https://buy.stripe.com/00w5kD5ZxbYDbtN9ESbQY0c",
    price: "$5,000",
    period: "2 months management included",
    badge: "Flagship",
    tagline: "The full transformation — Position, Convert, Automate, Scale — with HughLaunch embedded as your growth partner.",
    image: "https://static.prod-images.emergentagent.com/jobs/b7321a98-e256-4cb1-ae2f-2d5f3d3ad9af/images/1c343bdb947849c2e9f49fa8954aa43c69855b87643e41772bdb5582731210d7.jpeg",
    overview: "HD Brand Authority isn't a software bundle — it's a transformation. First we Position you: strategy and brand that make you the obvious choice in your market. Then we Convert: a cinematic presence engineered to turn attention into booked clients. Then we Automate: follow-up and pipelines so no lead ever slips. Then we Scale: weekly strategy and optimization that compound month after month. The technology — CRM, workflow automation, client portal, dashboards, analytics — is simply how we deliver it. With two months of hands-on management included, we operate as your embedded growth partner.",
    features: [
      "Position — strategy & brand that make you the obvious choice",
      "Convert — a presence engineered to book clients",
      "Automate — instant follow-up, nothing slips",
      "Scale — weekly strategy calls & website updates",
      "Under the hood: CRM integrations & workflow automation",
      "Under the hood: client portal, team dashboard & admin tools",
      "Under the hood: analytics dashboard & everything in Signature",
    ],
    delivery: "Launch timeline determined after strategy session",
    whoFor: [
      "Businesses ready to dominate their local market, not just participate in it",
      "Owners who want one growth partner accountable for outcomes — strategy, website, automation and optimization",
      "Teams drowning in manual follow-up who need CRM and automation doing the chasing for them",
    ],
    process: [
      { h: "Position", d: "Deep brand strategy — positioning, messaging and offer architecture that make you the obvious choice before a prospect ever picks up the phone." },
      { h: "Convert", d: "A cinematic digital presence engineered around your customer journey, built to turn attention into booked, paying clients." },
      { h: "Automate", d: "CRM integrations and follow-up workflows so every lead gets an instant response and nothing ever slips through the cracks." },
      { h: "Scale", d: "Two months of embedded management: weekly strategy calls, site updates and compounding optimization. Continues at $350/month — cancel anytime." },
    ],
    note: "Important: After your first two months of included management, HD Brand Authority continues at $350/month. You can cancel anytime — by either party, for any reason.",
    faqs: [
      { q: "What's the difference from Signature Presence?", a: "Authority adds ongoing partnership: weekly updates and strategy, CRM and automation, and a custom client portal with dashboards and admin tools." },
      { q: "What is the client portal?", a: "A private, branded workspace where you and your team track projects, deliverables, invoices and analytics in one place." },
      { q: "How does the automation help?", a: "We connect your CRM and build custom workflows so leads are followed up instantly and nothing slips through the cracks." },
    ],
  },
];


export const CHAPTERS = [
  {
    no: "01",
    title: "Strategy",
    body: "We start with the math, not the mood board. Positioning, offer and funnel are engineered to win the customers you actually want.",
  },
  {
    no: "02",
    title: "Systems",
    body: "Websites, automations and follow-up that run while you sleep. We build the machine so growth stops depending on your calendar.",
  },
  {
    no: "03",
    title: "Results",
    body: "More booked calls, more closed deals, more revenue you can trace. We report on outcomes, never vanity metrics.",
  },
];

export const MISSION =
  "We exist to launch bold brands and businesses into their next stage of growth — turning raw talent into a magnetic digital presence, real offers, and revenue that compounds.";

export const HUGH_ACRONYM = [
  { letter: "H", title: "Highlight", body: "Identify your most profitable skill or talent." },
  { letter: "U", title: "Upgrade", body: "Build your digital presence — website, reels, portfolio." },
  { letter: "G", title: "Generate", body: "Create offers — ebooks, courses, services." },
  { letter: "H", title: "Harvest", body: "Drive traffic and convert it into income." },
];


export const SERVICES = [
  {
    tag: "01",
    title: "Growth Websites",
    discipline: "Design",
    disciplineNote: "Premium, conversion-first",
    body: "The engine — a high-converting site that turns attention into booked appointments.",
    span: "lg:col-span-7",
  },
  {
    tag: "02",
    title: "Paid Acquisition + Client Portals",
    discipline: "Acquisition",
    disciplineNote: "Systems that book clients",
    body: "The fuel — Meta & Google ads sending ready-to-buy traffic straight into your engine, backed by custom client portals and employee dashboards to run it all.",
    span: "lg:col-span-5",
  },
  {
    tag: "03",
    title: "Lead Automation",
    discipline: "Strategy",
    disciplineNote: "Every build starts with a plan",
    body: "The safety net — instant follow-up and nurture so no lead the system creates ever slips.",
    span: "lg:col-span-5",
  },
  {
    tag: "04",
    title: "Local SEO",
    discipline: "Positioning",
    disciplineNote: "Stand out — get chosen",
    body: "The compounder — owning the map pack so the system keeps filling your calendar on its own.",
    span: "lg:col-span-7",
  },
];

export const CASE_STUDIES = [
  {
    client: "Meridian Cafe",
    metric: "+312%",
    label: "Online orders in 90 days",
    image:
      "https://images.unsplash.com/photo-1765648636178-60e73bcc865e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxsb2NhbCUyMGJ1c2luZXNzJTIwb3duZXIlMjBjYWZlJTIwc2hvcCUyMGNvbmZpZGVudCUyMHBvcnRyYWl0fGVufDB8fHx8MTc4Njg2NzQ4Nnww&ixlib=rb-4.1.0&q=85",
  },
  {
    client: "Northside Fitness",
    metric: "+188",
    label: "New members / quarter",
    image:
      "https://images.unsplash.com/photo-1776699549804-e0af10cdc495?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxsb2NhbCUyMGJ1c2luZXNzJTIwb3duZXIlMjBjYWZlJTIwc2hvcCUyMGNvbmZpZGVudCUyMHBvcnRyYWl0fGVufDB8fHx8MTc4Njg2NzQ4Nnww&ixlib=rb-4.1.0&q=85",
  },
  {
    client: "Harbor Dental",
    metric: "4.2x",
    label: "Return on ad spend",
    image:
      "https://images.unsplash.com/photo-1765648763932-43a3e2f8f35c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxsb2NhbCUyMGJ1c2luZXNzJTIwb3duZXIlMjBjYWZlJTIwc2hvcCUyMGNvbmZpZGVudCUyMHBvcnRyYWl0fGVufDB8fHx8MTc4Njg2NzQ4Nnww&ixlib=rb-4.1.0&q=85",
  },
];

export const STATS = [
  { value: "Strategy", label: "Every build starts with a plan" },
  { value: "Positioning", label: "Stand out — get chosen" },
  { value: "Design", label: "Premium, conversion-first" },
  { value: "Acquisition", label: "Systems that book clients" },
];

export const TESTIMONIALS = [
  {
    quote:
      "HughLaunch rebuilt our funnel and we went from 4 leads a week to 4 a day. They treat our revenue like their own.",
    name: "Alicia Moreno",
    role: "Owner, Meridian Cafe",
  },
  {
    quote:
      "The systems they installed run themselves. We finally have a growth engine, not just a pretty website.",
    name: "Dev Patel",
    role: "Founder, Northside Fitness",
  },
  {
    quote:
      "Straight-talking, results-obsessed and fast. Best money we've spent on the business, full stop.",
    name: "Karen Wu",
    role: "Practice Lead, Harbor Dental",
  },
];
